export default "/images/vendor/flag-icon-css/flags/4x3/sj.svg?f8f9b21529bdc34df1b56eb5523e0977";